export var dateFormat = 'dd.MM.yy';
export var initFilterValues = {};
